import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import '../userstatus.css';
import API from '../api';

const UserStatus = () => {
  const { user, login, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await API.post('/logout', null, { withCredentials: true });

      logout(); // Clear context
      localStorage.removeItem('user');

      // Delay navigation slightly to prevent racing state updates
      setTimeout(() => {
        navigate('/login', { replace: true });
      }, 100);
    } catch (error) {
      console.error('Logout failed:', error);
      logout();
      navigate('/login', { replace: true });
    }
  };

  return (
    <div>
      {user ? (
  
  <div className="user-info">
    <span>
      Welcome, {user.name || user.email}
    </span>
    <button onClick={handleLogout} className="logout-button">
      Logout
    </button>
  </div>

      ) : (
        <ul className="list-unstyled d-flex flex-wrap flex-md-row gap-2">
          <li>
            <a className="btn btn-primary w-100 w-md-auto" href="/signup">SIGN UP</a>
          </li>
          <li>
            <a className="btn btn-primary w-100 w-md-auto" href="/login">LOGIN</a>
          </li>
        </ul>
      )}
    </div>
  );
};

export default UserStatus;
